/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArc = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M16 2h6v6h-6V3zm2 2v2h2V4zM2 16h6v6H2v-5zm2 2v2h2v-2zm9.823-11.924C14.208 6.026 14.601 6 15 6h.5V4H15c-.486 0-.965.032-1.435.093zM9.521 7.86a8.988 8.988 0 0 1 2.034-1.176l-.766-1.848c-.895.371-1.73.857-2.486 1.438zm-2.838 3.696a9 9 0 0 1 1.176-2.034L6.273 8.303a10.99 10.99 0 0 0-1.438 2.486zM6 15c0-.4.026-.792.076-1.177l-1.983-.258C4.032 14.035 4 14.514 4 15v.5h2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgArc as Arc };
